import onboarding, { OnboardingState } from '~/pages/Onboarding/store/onboarding.reducers';
import storeConnect, {
  StoreConnectState,
} from '~/pages/StoreConnections/store/store-connect.reducers';
import address, { AddressState } from './address/address.reducer';
import analytics, { AnalyticsState } from './analytics/analytics.reducer';
import auth, { AuthState } from './auth/auth.reducer';
import automations, { AutomationsState } from './automations/automations.reducer';
import batchEntry, { BatchEntryState } from './batch-entry/batch-entry.reducer';
import billing, { BillingState } from './billing/billing.reducer';
import branding, { BrandingState } from './branding/branding.reducer';
import carrierAccounts, { CarrierAccountsState } from './carrier-accounts/carrier-accounts.reducer';
import carrierFormFields, {
  CarrierFormFieldsState,
} from './carrier-form-fields/carrier-form-fields.reducer';
import csvImport, { CSVState } from './csv-import/csv-import.reducer';
import dialog, { DialogState } from './dialog/dialog.reducer';
import featureTests, { FeatureTestsState } from './feature-tests/feature-tests.reducer';
import filters, { FiltersState } from './filters/filters.reducer';
import help, { HelpState } from './help/help.reducer';
import invoiceItems, { InvoiceItemsState } from './invoice-items/invoice-items.reducer';
import invoices, { InvoicesState } from './invoices/invoices.reducer';
import labelSettings, { LabelSettingsState } from './label-settings/labels.settings.reducer';
import lineItem, { LineItemState } from './line-item/line-item.reducer';
import login, { LoginState } from './login/login.reducer';
import manifests, { ManifestsState } from './manifests/manifests.reducer';
import manualOrder, { ManualOrderState } from './manual-order/manual-order.reducer';
import notifications, { NotificationsState } from './notifications/notifications.reducer';
import ordersBatch, { OrdersBatchState } from './orders-batch/orders-batch.reducer';
import orders, { OrdersState } from './orders/orders.reducer';
import packages, { PackagesState } from './packages/packages.reducer';
import parcelTemplate, { ParcelTemplateState } from './parcel-template/parcel-template.reducer';
import pendingInvoiceTransactions, {
  PendingInvoiceTransactionsState,
} from './pending-invoice-transactions/pending-invoice-transactions.reducer';
import pickups, { PickupsState } from './pickups/pickups.reducer';
import plans, { PlansState } from './plans/plans.reducer';
import promos, { PromosState } from './promos/promos.reducer';
import providers, { ProvidersState } from './providers/providers.reducer';
import ratesAtCheckout, {
  RatesAtCheckoutState,
} from './rates-at-checkout/rates-at-checkout.reducer';
import rates, { RatesState } from './rates/rates.reducer';
import shipments, { ShipmentsState } from './shipments/shipments.reducer';
import shippingMethods, { ShippingMethodsState } from './shipping-methods/shipping-methods.reducer';
import snackbar, { SnackbarState } from './snackbar/snackbar.reducer';
import stores, { StoresState } from './stores/stores.reducer';
import stripe, { StripeState } from './stripe/stripe.reducer';
import trackingSettings, {
  TrackingSettingsState,
} from './tracking-settings/tracking-settings.reducer';
import transactions, { TransactionsState } from './transactions/transactions.reducer';
import upsell, { UpsellState } from './upsell/upsell.reducer';
import user, { UserState } from './user/user.reducer';

export default {
  manifests,
  address,
  analytics,
  auth,
  automations,
  batchEntry,
  billing,
  branding,
  carrierAccounts,
  carrierFormFields,
  csvImport,
  dialog,
  featureTests,
  filters,
  help,
  invoices,
  invoiceItems,
  labelSettings,
  lineItem,
  login,
  manualOrder,
  notifications,
  orders,
  ordersBatch,
  packages,
  parcelTemplate,
  pendingInvoiceTransactions,
  pickups,
  plans,
  promos,
  providers,
  rates,
  ratesAtCheckout,
  shipments,
  shippingMethods,
  snackbar,
  stores,
  storeConnect,
  stripe,
  transactions,
  trackingSettings,
  upsell,
  user,
  onboarding,
};

export interface Reducers {
  address: AddressState;
  analytics: AnalyticsState;
  auth: AuthState;
  automations: AutomationsState;
  batchEntry: BatchEntryState;
  billing: BillingState;
  branding: BrandingState;
  carrierAccounts: CarrierAccountsState;
  carrierFormFields: CarrierFormFieldsState;
  csvImport: CSVState;
  dialog: DialogState;
  featureTests: FeatureTestsState;
  filters: FiltersState;
  help: HelpState;
  invoices: InvoicesState;
  invoiceItems: InvoiceItemsState;
  labelSettings: LabelSettingsState;
  lineItem: LineItemState;
  login: LoginState;
  manualOrder: ManualOrderState;
  notifications: NotificationsState;
  orders: OrdersState;
  ordersBatch: OrdersBatchState;
  packages: PackagesState;
  parcelTemplate: ParcelTemplateState;
  pendingInvoiceTransactions: PendingInvoiceTransactionsState;
  pickups: PickupsState;
  plans: PlansState;
  promos: PromosState;
  providers: ProvidersState;
  rates: RatesState;
  ratesAtCheckout: RatesAtCheckoutState;
  trackingSettings: TrackingSettingsState;
  shipments: ShipmentsState;
  shippingMethods: ShippingMethodsState;
  snackbar: SnackbarState;
  stores: StoresState;
  storeConnect: StoreConnectState;
  stripe: StripeState;
  transactions: TransactionsState;
  upsell: UpsellState;
  user: UserState;
  manifests: ManifestsState;
  onboarding: OnboardingState;
}
